export const asyncForEach = async (arr, callback) => {
    for (let idx = 0; idx < arr.length; idx++) {
        await callback(arr[idx], idx, arr);
    }
};
